import React, { FC } from 'react';
import { Text, Icon, IconSize, Box } from '@bechtel/gds';
import { ToggleBoxStyled } from './styled';
import { useLingui } from '@lingui/react';

interface SectionToggleProps {
  isOpen: boolean;
  toggle: (isOpen: boolean) => void;
  heading: string;
}

export const SectionToggle: FC<SectionToggleProps> = ({ isOpen, toggle, heading }) => {
  const { i18n } = useLingui();
  return (
    <ToggleBoxStyled onClick={() => toggle(!isOpen)}>
      <Box alignItems={{ sm: 'center' }}>
        <Icon icon={isOpen ? 'chevron-down' : 'chevron-up'} fillColor="blue.700" size={IconSize.SMALL} />
        &nbsp;&nbsp;
        <Text size="400" color="grey.1000" weight="600" family="graphik">
          {i18n._(heading)}
        </Text>
      </Box>
    </ToggleBoxStyled>
  );
};
